import { render, staticRenderFns } from "./ExpertList.vue?vue&type=template&id=8c8b3070&scoped=true&"
import script from "./ExpertList.vue?vue&type=script&lang=js&"
export * from "./ExpertList.vue?vue&type=script&lang=js&"
import style0 from "./ExpertList.vue?vue&type=style&index=0&id=8c8b3070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8b3070",
  null
  
)

export default component.exports